import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useShell } from '@/context/shell-context';
import { logoutSession } from '@/security/session';
import type { TLocalize } from '@hooks/use-localize';

interface IProps {
    t: TLocalize;
}

const Welcome = ({ t }: IProps) => {
    const shell = useShell();
    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isOpen) return;

        const onDocumentClick = (event: MouseEvent) => {
            if (!containerRef.current?.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', onDocumentClick);

        return () => document.removeEventListener('click', onDocumentClick);
    }, [isOpen]);

    if (!shell.registrationId || !shell.firstName) return null;

    const onProfile = () => {
        setIsOpen(false);
    };

    const onLogout = async () => {
        setIsOpen(false);

        await logoutSession();

        navigate('/register/auth-login', { replace: true });
    };

    return (
        <div className={'welcome-menu dropdown' + (isOpen ? ' open' : '')} ref={containerRef}>
            <button
                type="button"
                className="welcome-chip"
                aria-haspopup="true"
                aria-expanded={isOpen}
                onClick={() => setIsOpen(!isOpen)}
            >
                <i className="fas fa-user-circle welcome-chip__icon" aria-hidden="true"></i>
                {t('DashLabel_Welcome', 'Welcome')}, {shell.firstName}!
                <span className="caret welcome-chip__caret"></span>
            </button>

            <ul className="dropdown-menu dropdown-menu-right">
                <li>
                    <a
                        href="#"
                        onClick={(event) => {
                            event.preventDefault();
                            onProfile();
                        }}
                    >
                        {t('DashLabel_Profile', 'Profile')}
                    </a>
                </li>
                <li>
                    <a
                        href="#"
                        onClick={(event) => {
                            event.preventDefault();
                            onLogout();
                        }}
                    >
                        {t('DashLabel_Logout', 'Logout')}
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default Welcome;
